// extracted by mini-css-extract-plugin
export default {"brandPromo":"zE-z","carousel":"AE-z"};